import BaseApiService from "./base-services/baseApi.service";

class CareersApiService extends BaseApiService {
    constructor() {
        super();
    }

    jobList = async () => {
        const url = `/website/careers/job-list`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    jobDetails = async (jobId) => {
        const url = `/website/careers/job-detail?jobId=${jobId}`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    applyJob = async (payload) => {
        const url = `/website/careers/apply-job`;
        const res = await this.axiosInstance.post(url, payload);
        return await res.data;
    };

    uploadJobAttachment = async (formData) => {
        const url = `/action/upload-job-attachment`;
        const res = await this.axiosInstance.post(url, formData);
        return await res.data;
    };
}
const careersApiService = new CareersApiService();
export { careersApiService };
